import $ from "jquery"; //eslint-disable-line
import 'assets/styles/fonts.scss';
import 'assets/styles/normalize.scss';

import "../../../node_modules/slick-carousel/slick/slick.min.js";
import "../../../node_modules/slick-carousel/slick/slick.scss";
import "../../../node_modules/slick-carousel/slick/slick-theme.scss";

import 'pages/index/index.scss';

window.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth <= 1024) {
        $(".header__tips").slick({
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $(".header__movies").slick({
            infinite: false,
            adaptiveHeight: true,
        });
        $(".bottom__movies").slick({
            infinite: false,
            adaptiveHeight: true,
        });
/* eslint-disable no-alert, no-console */
    // eslint-disable-next-line no-unused-vars
        $('.header__movies').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slick-current iframe').attr('src', $('.slick-current iframe').attr('src'));
        });
/* eslint-enable no-alert, no-console */
/* eslint-disable no-alert, no-console */
    // eslint-disable-next-line no-unused-vars
        $('.bottom__movies').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slick-current iframe').attr('src', $('.slick-current iframe').attr('src'));
        });
/* eslint-enable no-alert, no-console */
    } else {
        $('.header__tips').slick('unslick');
        $('.header__movies').slick('unslick');
        $('.bottom__movies').slick('unslick');
    }
});

window.addEventListener('resize', () => {
    if (window.innerWidth <= 1024) {
        $(".header__tips").slick({
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        $(".header__movies").slick({
            infinite: false,
            adaptiveHeight: true,
        });
        $(".bottom__movies").slick({
            infinite: false,
            adaptiveHeight: true,
        });
/* eslint-disable no-alert, no-console */
    // eslint-disable-next-line no-unused-vars
        $('.header__movies').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slick-current iframe').attr('src', $('.slick-current iframe').attr('src'));
        });
/* eslint-enable no-alert, no-console */
/* eslint-disable no-alert, no-console */
    // eslint-disable-next-line no-unused-vars
        $('.bottom__movies').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slick-current iframe').attr('src', $('.slick-current iframe').attr('src'));
        });
/* eslint-enable no-alert, no-console */
    } else {
        $('.header__tips').slick('unslick');
        $('.header__movies').slick('unslick');
        $('.bottom__movies').slick('unslick');
    }
});